export const ReviewsPrefixes = {
  Analytics: 'reviews-analytics',
  Settings: 'reviews-settings',
};
